import { motion } from "framer-motion";
import { Phone, Search, Cpu, IndianRupee } from "lucide-react";

const steps = [
  { n: "01", icon: Phone, t: "Get in Touch", d: "Connect with the Biker Boulevard team in seconds — call, chat, or schedule online." },
  { n: "02", icon: Search, t: "Vehicle Inspection", d: "Our certified team inspects your motorcycle end-to-end at a location convenient to you." },
  { n: "03", icon: Cpu, t: "Smart Valuation", d: "Our valuation app calculates the exact real-time value of your vehicle using live market signals." },
  { n: "04", icon: IndianRupee, t: "Instant Payout", d: "Accept the price and receive a bank-grade payout, instantly. Your bike is sold." },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-it-works-section" className="relative py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0 metallic-bg" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <span className="text-xs font-mono tracking-[0.3em] uppercase text-[#00cccc]">// How It Works</span>
          <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tight">
            Four Steps. <span className="text-gradient-cyan">Zero Friction.</span>
          </h2>
          <p className="mt-5 text-zinc-400 text-lg max-w-xl">A cinematic process built for riders who refuse to waste time.</p>
        </motion.div>

        <div className="mt-16 relative">
          {/* Connector line - desktop */}
          <div className="hidden md:block absolute top-[88px] left-0 right-0 h-[1px]">
            <div className="h-full bg-gradient-to-r from-transparent via-[#00cccc]/40 to-transparent" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                className="relative group"
                data-testid={`how-it-works-step-${i + 1}`}
              >
                {/* Numbered node */}
                <div className="relative w-20 h-20 mx-auto md:mx-0 mb-6 flex items-center justify-center">
                  <div className="absolute inset-0 rounded-full bg-[#00cccc]/10 border border-[#00cccc]/30 group-hover:bg-[#00cccc]/20 group-hover:border-[#00cccc]/60 transition-all duration-500" style={{ boxShadow: "0 0 24px rgba(0,204,204,0.2)" }} />
                  <s.icon className="w-7 h-7 text-[#00cccc] relative z-10" />
                  <span className="absolute -top-2 -right-2 text-xs font-mono text-[#00cccc] bg-[#0D0F12] px-2 py-0.5 border border-[#00cccc]/40 rounded-md">{s.n}</span>
                </div>
                <div className="p-5 rounded-xl glass hover:border-[#00cccc]/40 transition-all duration-300">
                  <h3 className="text-lg font-semibold text-white">{s.t}</h3>
                  <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{s.d}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
